var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useCallback, useState } from 'react';
import { HotlineClientScheduleApplication } from '@/feature/hotline/client/detail/negotiate/component/HotlineClientSchedule/HotlineClientScheduleApplication/HotlineClientScheduleApplication';
import { HotlineClientScheduleEnd } from '@/feature/hotline/client/detail/negotiate/component/HotlineClientSchedule/HotlineClientScheduleEnd';
import { HotlineClientScheduling } from '@/feature/hotline/client/detail/negotiate/component/HotlineClientSchedule/HotlineClientScheduling';
import { HotlineClientScheduleConfirmModal, useHotlineClientScheduleConfirmModal, } from '@/feature/hotline/client/detail/negotiate/component/HotlineClientScheduleConfirmModal';
import { formatProfessionalDataToUserBox } from '@/feature/hotline/client/util/formatApiDataToUi';
import { HotlineCancelModal, useHotlineCancelModal, } from '@/feature/hotline/component/HotlineCancelModal';
import { HotlineScheduleChangeModal, useHotlineScheduleChangeModal, } from '@/feature/hotline/component/HotlineScheduleChangeModal';
import { HOTLINE_INTERVIEW_STATUS_BLOCK, HOTLINE_INTERVIEW_STATUS_ACCEPT, HOTLINE_INTERVIEW_STATUS_COMPLETED, } from '@/feature/hotline/constant/interviewStatus';
import { HOTLINE_USER_TYPE_CLIENT } from '@/feature/hotline/constant/userType';
import { useUnmountRef } from '@/hooks/lifecycle/useUnmountRef';
/**
 * 匿名コンサルホットライン スケジュール調整
 */
export const HotlineClientSchedule = (props) => {
    const { className = '', id, onSubmitAccept: propsOnSubmitAccept, onSubmitCancel: propsOnSubmitCancel, onSubmitSchedule: propsOnSubmitSchedule, onSubmitScheduleChange: propsOnScheduleChange, professional, requestId, requestInterview, } = props;
    const unmountRef = useUnmountRef();
    // 面談ID
    const interviewId = (requestInterview === null || requestInterview === void 0 ? void 0 : requestInterview.id) || null;
    // 選択中の日程
    const [scheduleFormValue, setScheduleFormValue] = useState();
    // 日程確認モーダル開閉状態, 送信処理
    const { closeScheduleConfirmModal, isOpenScheduleConfirmModal, onSubmitScheduleConfirm, openScheduleConfirmModal, } = useHotlineClientScheduleConfirmModal({
        interviewId,
        onSubmit: propsOnSubmitSchedule,
        requestId,
        unmountRef,
    });
    // 日程変更モーダル開閉状態, 送信処理
    const { closeScheduleChangeModal, isOpenScheduleChangeModal, onSubmitScheduleChange, openScheduleChangeModal, } = useHotlineScheduleChangeModal({
        interviewId,
        onSubmit: propsOnScheduleChange,
        requestId,
        unmountRef,
    });
    // 相談キャンセルモーダル開閉状態, 送信処理
    const { closeCancelModal, isOpenCancelModal, onSubmitCancel, openCancelModal, } = useHotlineCancelModal({
        interviewId,
        onSubmit: propsOnSubmitCancel,
        requestId,
        unmountRef,
    });
    /**
     * スケジュール日程 申し込み ボタンクリック時の処理
     */
    const onClickSubmitSchedule = useCallback((formValues) => __awaiter(void 0, void 0, void 0, function* () {
        // 日程を保持
        setScheduleFormValue(formValues);
        // 確認モーダルを表示
        openScheduleConfirmModal();
    }), [openScheduleConfirmModal, setScheduleFormValue]);
    /**
     * スケジュール承認 送信処理
     */
    const onSubmitAccept = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        if (!interviewId) {
            return;
        }
        yield (propsOnSubmitAccept === null || propsOnSubmitAccept === void 0 ? void 0 : propsOnSubmitAccept(requestId, interviewId));
    }), [interviewId, propsOnSubmitAccept, requestId]);
    return (_jsxs(_Fragment, { children: [(() => {
                // 相談情報が存在しない場合
                if (!requestInterview) {
                    return (_jsx(HotlineClientScheduleApplication, { className: className, onClickCancel: openCancelModal, onSubmit: onClickSubmitSchedule }));
                }
                // 完了の場合
                if (requestInterview.status === HOTLINE_INTERVIEW_STATUS_COMPLETED.value) {
                    return (_jsx(HotlineClientScheduleEnd, { className: className, id: id, isCanceled: false, requestId: requestId }));
                }
                // キャンセルの場合
                if (requestInterview.status === HOTLINE_INTERVIEW_STATUS_BLOCK.value) {
                    return (_jsx(HotlineClientScheduleEnd, { className: className, id: id, isCanceled: true, requestId: requestId }));
                }
                // 相談日時が未設定の場合
                if (!requestInterview.interviewed_from_at ||
                    !requestInterview.interviewed_to_at) {
                    return (_jsx(HotlineClientScheduleApplication, { className: className, onClickCancel: openCancelModal, onSubmit: onClickSubmitSchedule }));
                }
                // 日程調整中・受諾済みの場合
                return (_jsx(HotlineClientScheduling, { className: className, interviewedFromAt: requestInterview.interviewed_from_at, interviewedToAt: requestInterview.interviewed_to_at, isFixed: requestInterview.status === HOTLINE_INTERVIEW_STATUS_ACCEPT.value, isSelf: requestInterview.user_type === HOTLINE_USER_TYPE_CLIENT.value, onClickAccept: onSubmitAccept, onClickCancel: openCancelModal, onClickChange: openScheduleChangeModal }));
            })(), scheduleFormValue && professional && (_jsx(HotlineClientScheduleConfirmModal, { formValues: scheduleFormValue, isShow: isOpenScheduleConfirmModal, onClickBack: closeScheduleConfirmModal, onSubmit: onSubmitScheduleConfirm, user: formatProfessionalDataToUserBox(professional) })), !!(requestInterview === null || requestInterview === void 0 ? void 0 : requestInterview.interviewed_from_at) &&
                !!(requestInterview === null || requestInterview === void 0 ? void 0 : requestInterview.interviewed_to_at) && (_jsx(HotlineScheduleChangeModal, { interviewedFromAt: requestInterview.interviewed_from_at, interviewedToAt: requestInterview.interviewed_to_at, isShow: isOpenScheduleChangeModal, onClickBack: closeScheduleChangeModal, onSubmit: onSubmitScheduleChange, type: 'client' })), _jsx(HotlineCancelModal, { isShow: isOpenCancelModal, onClickBack: closeCancelModal, onSubmit: onSubmitCancel, type: 'client' })] }));
};
